function getLocationStepState(state) {
  return {
    hasCoordinates: state.locationStep.coordinates,
    isEdited: state.locationStep.isEdited,
    hasLocation: state.locationStep.hasLocation,
    getLocationLoading: state.locationStep.getLocationLoading,
    formValues: {
      address: state.locationStep.address,
      selectedProvince: state.locationStep.selectedProvince,
      selectedCity: state.locationStep.selectedCity,
      selectedDistrict: state.locationStep.selectedDistrict,
      selectedSubDistrict: state.locationStep.selectedSubDistrict,
      provinceData: state.locationStep.provinceData,
      cityData: state.locationStep.cityData,
      districtData: state.locationStep.districtData,
      subDistrictData: state.locationStep.subDistrictData,
      locationInfo: state.locationStep.locationInfo[0],
      postalCode: state.locationStep.postalCode
    },
    hasValues: state.locationStep.hasValues,
    isCompleted: state.locationStep.isCompleted,
    getFormValuesError: state.locationStep.getFormValuesError,
    visibility: state.locationStep.visibility,
    cep: state.locationStep.cep,
    cepError: state.locationStep.cepError,
    cepNotFound: state.locationStep.cepNotFound,
    loadingCep: state.locationStep.loadingCep,
    loadingDistrict: state.locationStep.loadingDistrict,
    addressComplement: state.locationStep.addressComplement,
    zonaDemandIds: state.locationStep.zonaDemandIds,
    hasDataSavedOnDB: state.locationStep.hasDataSavedOnDB
  };
}

export { getLocationStepState };
